<template>
  <Message v-if="visible" severity="error" class="my-2" icon="pi pi-exclamation-triangle" @close="onMessageClose" closable >
    {{ message }}
  </Message>
</template>

<script setup>
import Message from 'primevue/message';

const onMessageClose = () => {
    emit('close');
};

defineProps({
    visible: {
        type: [Boolean, null],
        default: false
    },
    message: {
        type: [String, null],
        default: 'An error has occurred while processing your request. Please try again.'
    }
});


const emit = defineEmits(['close']);

</script>
